import api from './api';

export interface EmailCampaignData {
  id?: string;
  name: string;
  subject: string;
  content: string;
  status?: 'draft' | 'scheduled' | 'sending' | 'sent' | 'failed';
  target_all?: boolean;
  target_plans?: string[];
  target_users?: string[];
  scheduled_at?: string;
  sent_at?: string;
  total_recipients?: number;
  emails_sent?: number;
  emails_failed?: number;
  emails_opened?: number;
  emails_clicked?: number;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  open_rate?: number;
  click_rate?: number;
}

export interface EmailCampaignStats {
  total_recipients: number;
  emails_sent: number;
  emails_failed: number;
  emails_opened: number;
  emails_clicked: number;
  open_rate: number;
  click_rate: number;
}

export interface EmailPreview {
  subject: string;
  content: string;
  recipient_count: number;
  recipients_preview: string[];
}

// Obter todas as campanhas
export const getAllCampaigns = async (status?: string): Promise<EmailCampaignData[]> => {
  try {
    const params = status ? { status_filter: status } : {};
    const response = await api.get('/email-campaigns', { params });
    return response.data;
  } catch (error: any) {
    console.error('Erro ao buscar campanhas:', error);
    throw error;
  }
};

// Obter uma campanha específica
export const getCampaign = async (campaignId: string): Promise<EmailCampaignData> => {
  try {
    const response = await api.get(`/email-campaigns/${campaignId}`);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao buscar campanha:', error);
    throw error;
  }
};

// Criar uma nova campanha
export const createCampaign = async (campaign: EmailCampaignData): Promise<EmailCampaignData> => {
  try {
    const response = await api.post('/email-campaigns', campaign);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao criar campanha:', error);
    throw error;
  }
};

// Atualizar uma campanha
export const updateCampaign = async (campaignId: string, campaign: Partial<EmailCampaignData>): Promise<EmailCampaignData> => {
  try {
    const response = await api.put(`/email-campaigns/${campaignId}`, campaign);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao atualizar campanha:', error);
    throw error;
  }
};

// Deletar uma campanha
export const deleteCampaign = async (campaignId: string): Promise<void> => {
  try {
    await api.delete(`/email-campaigns/${campaignId}`);
  } catch (error: any) {
    console.error('Erro ao deletar campanha:', error);
    throw error;
  }
};

// Pré-visualizar campanha
export const previewCampaign = async (campaignId: string): Promise<EmailPreview> => {
  try {
    const response = await api.post(`/email-campaigns/${campaignId}/preview`);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao pré-visualizar campanha:', error);
    throw error;
  }
};

// Enviar campanha
export const sendCampaign = async (campaignId: string): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await api.post(`/email-campaigns/${campaignId}/send`);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao enviar campanha:', error);
    throw error;
  }
};

// Enviar email de teste
export const sendTestEmail = async (campaignId: string, testEmail: string): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await api.post(`/email-campaigns/${campaignId}/test`, null, {
      params: { test_email: testEmail }
    });
    return response.data;
  } catch (error: any) {
    console.error('Erro ao enviar email de teste:', error);
    throw error;
  }
};

// Obter estatísticas de uma campanha
export const getCampaignStats = async (campaignId: string): Promise<EmailCampaignStats> => {
  try {
    const response = await api.get(`/email-campaigns/${campaignId}/stats`);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao buscar estatísticas:', error);
    throw error;
  }
};



